import { Form, Input, Modal, Button, message } from 'antd';
import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { UpdatePassword } from '../../api/user';
import { toastMessage } from '../../utils/Utils';
export default function UpdatePasswordModal(props) {
  const { state, setState } = props;
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    setState({ ...state, loading: true });
    const payload = {
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
      confirmNewPassword: values.confirmNewPassword,
    };
    try {
      const { data } = await UpdatePassword(payload);
      message.success(toastMessage(data.message, 'green'));
      setState({ ...state, loading: false, isModalVisible: false });
      form.resetFields();
    } catch (ex) {
      setState({ ...state, loading: false });
    }
  };

  const handleCancel = () => {
    setState({ isModalVisible: false });
    form.resetFields();
  };

  return (
    <Modal
      title="Update Password"
      className="rounded-[30px] overflow-hidden bg-white -mt-10"
      open={state.isModalVisible}
      onCancel={handleCancel}
      width={350}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="flex flex-col gap-3 pt-4"
      >
        <Form.Item
          className=""
          name="currentPassword"
          label="CurrentPassword"
          rules={[{ required: true }]}
        >
          <Input
            variant="borderless"
            className="bg-[#EEF0F2] w-full h-8 text-[#5B6268] rounded-lg"
            placeholder="Previous Password"
          />
        </Form.Item>
        <Form.Item
          className=""
          name="newPassword"
          label="NewPassword"
          rules={[{ required: true }]}
        >
          <Input
            variant="borderless"
            className="bg-[#EEF0F2] w-full h-8  text-[#5B6268] rounded-lg"
            placeholder="New Password"
          />
        </Form.Item>
        <Form.Item
          className=""
          name="confirmNewPassword"
          label="confirmNewPassword"
          rules={[{ required: true }]}
        >
          <Input
            variant="borderless"
            className="bg-[#EEF0F2] w-full h-8  text-[#5B6268] rounded-lg"
            placeholder="New Password again"
          />
        </Form.Item>
        <div className="col-span-2 flex justify-end mt-2">
          <Button
            onClick={handleCancel}
            icon={<DeleteOutlined className="text-xs" />}
            className="rounded-xl font-bold  flex justify-center items-center  h-10 text-red-500 bg-transparent border-none"
          >
            Cancel
          </Button>
          <Button
            loading={state.loading}
            htmlType="submit"
            className="rounded-2xl flex justify-around items-center w-24 h-9 text-xs text-white bg-[#6E6FF7]"
          >
            Confirm
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
